// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CallSelectMemberPopup__list-c14d13 {
  flex: 1;
}

.CallSelectMemberPopup__search-dad08e {
  margin: 16px 24px;
}

.CallSelectMemberPopup__button-d5350f {
  display: flex;
  align-items: center;
  font: var(--font-body-2);
  letter-spacing: var(--font-spacing-body-2);
  color: var(--brand-primary-40);
  margin-top: 12px;
  margin-bottom: 36px;
  margin-inline-start: 24px;
  margin-inline-end: 12px;
  cursor: pointer;
}

.CallSelectMemberPopup__icon-e27965 {
  margin-inline-end: 24px;
  fill: currentColor;
}

.CallSelectMemberPopup__placeholders-d4a32c {
  padding-inline-start: 24px;
}`, "",{"version":3,"sources":["webpack://./../../packages/call/src/popups/Permissions/CallSelectMemberPopup/CallSelectMemberPopup.styles.m.css"],"names":[],"mappings":"AAAA;EACE,OAAA;AACF;;AAEA;EACE,iBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,wBAAA;EACA,0CAAA;EACA,8BAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,uBAAA;EACA,eAAA;AACF;;AAEA;EACE,uBAAA;EACA,kBAAA;AACF;;AAEA;EACE,0BAAA;AACF","sourcesContent":[".list {\n  flex: 1;\n}\n\n.search {\n  margin: 16px 24px;\n}\n\n.button {\n  display: flex;\n  align-items: center;\n  font: var(--font-body-2);\n  letter-spacing: var(--font-spacing-body-2);\n  color: var(--brand-primary-40);\n  margin-top: 12px;\n  margin-bottom: 36px;\n  margin-inline-start: 24px;\n  margin-inline-end: 12px;\n  cursor: pointer;\n}\n\n.icon {\n  margin-inline-end: 24px;\n  fill: currentColor;\n}\n\n.placeholders {\n  padding-inline-start: 24px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"list": `CallSelectMemberPopup__list-c14d13`,
	"search": `CallSelectMemberPopup__search-dad08e`,
	"button": `CallSelectMemberPopup__button-d5350f`,
	"icon": `CallSelectMemberPopup__icon-e27965`,
	"placeholders": `CallSelectMemberPopup__placeholders-d4a32c`
};
module.exports = ___CSS_LOADER_EXPORT___;
